import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedContent from './components/FeaturedContent';
import CategoryGrid from './components/CategoryGrid';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';

export default function Home() {
  const webPageJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '亚洲精品视频精选合集 · 高清正版内容平台',
    description: '亚洲精品视频汇聚来自亚洲各地的高品质影视内容，涵盖电影、电视剧、纪录片、短片等多元类型。',
    url: 'https://beevpn.cn/',
    isPartOf: {
      '@type': 'WebSite',
      name: '亚洲精品视频',
      url: 'https://beevpn.cn',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(webPageJsonLd)}</script>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturedContent />
          <CategoryGrid />
          <LatestUpdates />
          <FAQSection />
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}